import httpClient from "./httpClient";

export async function registerUser({ name, email, password }) {
  const { data } = await httpClient.post("/auth/register", {
    name,
    email,
    password,
  });
  return data;
}

export async function loginUser({ email, password }) {
  const { data } = await httpClient.post("/auth/login", { email, password });
  return data;
}

export async function getMe() {
  const { data } = await httpClient.get("/auth/me");
  return data.user;
}

export async function requestPasswordReset(email) {
  const { data } = await httpClient.post("/auth/forgot-password", { email });
  return data;
}

export async function resetPasswordWithToken(token, password) {
  const { data } = await httpClient.post("/auth/reset-password", { token, password });
  return data;
}
